import styled from "@emotion/styled";
import { fontWeights, gutterSizes } from "@gumtree/ui-library/src/base/theme";

export const SellerPhoneRevealPanel = styled.div<{ isPro?: boolean; fullWidthButton?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > span:first-of-type {
        margin-right: ${gutterSizes.base};
    }

    ${({ isPro }) => isPro && "justify-content: unset;"}

    ${({ fullWidthButton }) =>
        fullWidthButton &&
        `
        width: 100%;

        & > a {
            width: 100%;

            & > button {
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: ${fontWeights.bold};
            }
        }
    `}
`;

export const SellerPhoneNumber = styled.div`
    display: flex;
    align-items: center;
    margin-right: ${gutterSizes.base};
`;

export const SellerPhoneNumberTitle = styled.h2`
    padding-left: ${gutterSizes.base};
    margin: 0;
`;
